import React from 'react'
import { Image, Segment, Header } from 'semantic-ui-react'

const GsrHrvMetric = (props) => (
    <Segment>
        <Header as='h2'>
            3. HOW YOUR BODY RESPONDS TO YOUR EMOTIONS
        </Header>
        <p>
            When you experience an emotion, your body responds with a change in your heart rate, 
            skin temperature, and the electrical activity of your skin, among other reactions. 
            Your Feel Emotion Sensor detects your heart rate and how the electrical 
            characteristics of your skin vary when you experience emotions in real-time. 
            The two charts below show the daily range of your Electrodermal Activity (EDA) 
            and Heart Rate (HR) (pink area), against the daily average (red line). 
            On both charts, you can see how your biosignals changed in the recent days 
            and some of the most intense emotions you experienced during the highs and lows.
        </p>
        <p>
            Please note that there is no direct correlation between the level of the biosignal and the emotion. 
            This depends and varies for every person, and doesn't mean that when the biosignal is low or high you 
            will always experience a certain emotion.
        </p>
        <p>
            Tip: Respond to the emotion notifications you receive while wearing your Feel Emotion Sensor to improve how well your biological
            data is tracked and correlated to your emotions
        </p>
        <Header as='h3'>
            Your Electrodermal Activity (EDA)
        </Header>
        <Image src={`data:image/jpeg;base64,${props.gsr_metric}`} alt={`${"gsr.png"}`} centered/>
        <Header as='h3'>
            Your Heart Rate
        </Header>
        <Image src={`data:image/jpeg;base64,${props.hrv_metric}`} alt={`${"hrv.png"}`} centered/>
    </Segment>
)

export default GsrHrvMetric



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/metrics/gsr-hrv.js